import Constants from '../constants/constants';
import { dispatcher } from '../dispatcher/dispatcher';
import { storeUtils } from './util';
const { ActionTypes } = Constants;
var _events = new storeUtils.EventEmitter();
var CHANGE_EVENT = 'change';
var ServerApi = require('../actions/serverAPI');
import { subdivisionStore } from './subdivision';
var Validator = require('../util/formValidation');

var _compareList = [];
var _message = "";
var _compareListLoading = false;
var _restrictionLoading = false;
var _rowClicked = false;
var _guidListLoading = false;
var _form;
var _compareGuidListItems = [];
//var _compareGuidAllListItems = [];
var _compareItemDetailsOpened = false;
var _compareItemListOpened = true;
var _showResult = false;
var _guidsWithColorCodes = [];
var _comparedItems = null;
var _isRunNotTriggered = true;
var _showUpdate = false;
var _height = 45;

var dispatchToken = dispatcher.register(function (action) {

    //this action comes from the dispatcher
    switch (action.type) {

        case ActionTypes.TOGGLE_COMPARE_LISTS:
            _compareItemDetailsOpened = !_compareItemDetailsOpened;
            _compareItemListOpened = !_compareItemListOpened;
            _rowClicked = false

            _events.trigger(CHANGE_EVENT);
            break;

        case ActionTypes.OPENING_RESTRICTION:
            _rowClicked = true;
            _events.trigger(CHANGE_EVENT);
            break;

        case ActionTypes.RESET_COMPARE_DETAILS:
            _guidsWithColorCodes = [];
            _compareGuidListItems = [];
            // _compareGuidAllListItems= [];
            _rowClicked = false;

            _form = null;
            _compareItemDetailsOpened = false;
            _compareItemListOpened = true;
            _events.trigger(CHANGE_EVENT);
            break;

        case ActionTypes.HISTORY_LIST_LOADED:
            _compareListLoading = false;
            _compareList = action.data;
            _events.trigger(CHANGE_EVENT);
            break;

        case ActionTypes.COMPARE_SUBDIVISION_CHANGED:
        case ActionTypes.COMPARE_GIS_ENVIRONMENT_CHANGED:
            _height = 45
            dispatcher.waitFor([subdivisionStore.dispatchToken]);

            var schematicRequested = action.selectedschematic
            var compareCall = ServerApi.getServerCompareResult(subdivisionStore.getSelectedSub(), schematicRequested);
            _isRunNotTriggered = true;
            compareCall.done(function success(data) {
                if (data.success) {
                    _comparedItems = data.data.items;
                } else {
                    _comparedItems = false;
                }
            }).fail(function failed(xhr, status, error) {
                console.log(error)
            });

        case ActionTypes.STORE_FORM_A_RESTRICTION:
            //Check that the form was loaded correctly before trying to open it
            if (action.form) {
                _form = action.form;
                console.log(ActionTypes.STORE_FORM_A_RESTRICTION, _form);
                //_events.trigger(CHANGE_EVENT);
            }
            break;


        case ActionTypes.STORE_FORM_A_REQUEST:
            //Check that the form was loaded correctly before trying to open it
            if (action.form) {
                _form = action.form;
                console.log(ActionTypes.STORE_FORM_A_REQUEST, _form);

            }
            break;


        case ActionTypes.STORE_FORM_B_RESTRICTION:
            //Check that the form was loaded correctly before trying to open it
            if (action.form) {
                _form = action.form;
                console.log(ActionTypes.STORE_FORM_B_RESTRICTION, _form);
                //_events.trigger(CHANGE_EVENT);
            }
            break;

        case ActionTypes.STORE_FORM_B_REQUEST:
            //Check that the form was loaded correctly before trying to open it
            if (action.form) {
                _form = action.form;
                console.log(ActionTypes.STORE_FORM_B_REQUEST, _form);
                //_events.trigger(CHANGE_EVENT);
            }
            break;
        case ActionTypes.GET_RUNCOMPARE:
            _showResult = true;
            _showUpdate = false;
            _height = 91;
            _isRunNotTriggered = false;
            _message = " Records Compared."
            _events.trigger(CHANGE_EVENT);
            break;

        case ActionTypes.GET_UPDATE:
            _showUpdate = true;

            _events.trigger(CHANGE_EVENT);
            break;

        case ActionTypes.GET_RUNCOMPARE_CLICKED:
            _showResult = true;
            _showUpdate = false;
            _message = " Records being compared. Please wait..."
            _events.trigger(CHANGE_EVENT);
            break;

        case ActionTypes.CLOSE_COMPARE_RESULTS:
            _showResult = false;
            _showUpdate = false;
            _events.trigger(CHANGE_EVENT);
            break;
        case ActionTypes.RESET_RUN_COMPARE_DETAILS:
            _showResult = false;
            _showUpdate = false;
            _message = "";
            _events.trigger(CHANGE_EVENT);
            break;

        case ActionTypes.COMPARE_ITEMS_SAVED:
            _guidsWithColorCodes = [];
            _events.trigger(CHANGE_EVENT);
            break;

        case ActionTypes.RUNCOMPARE_CALCULATED_GUIDS:
            _guidsWithColorCodes = action.results
            _events.trigger(CHANGE_EVENT);
            break;

        default:
        //no op
    }
});//end of dispatch token

export const runCompareStore = {
    subscribe: _events.on,
    unsubscribe: _events.off,
    dispatchToken,
    compareListLoading: function () {
        return _compareListLoading;
    },
    getCompareList: function () {
        return _compareList;
    },
    restrictionLoading: function () {
        return _restrictionLoading
    },
    getCompareGuids: function () {
        return _compareGuidListItems
    },

    guidListLoading: function () {
        return _guidListLoading
    },
    getDetailsOpened: function () {
        return _compareItemDetailsOpened
    },
    getListOpened: function () {
        return _compareItemListOpened
    },
    getForm: function () {
        return _form;
    },

    showResult: function () {
        return _showResult;
    },
    showUpdate: function () {
        return _showUpdate;
    },
    getRunCompareResults: function () {
        return _guidsWithColorCodes;
    },
    getComparedItems: function () {
        return _comparedItems;
    },
    getComparedMessage: function () {
        return _message;
    },
    getIsRunCompareTriggered: function () {
        return _isRunNotTriggered;
    }, getRowClicked: function () {
        return _rowClicked;
    },
    getHeight: function () {
        return _height;
    }
};
